import React from 'react';
import styled from 'styled-components';

export const FeedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LoadMore = styled.p`
  font: normal normal 14px Roboto;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.main};
  text-align: center;
  cursor: pointer;
  line-height: 20px;
  letter-spacing: 0.17px;
  margin: 0px 15px 0px 15px;
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
